import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Text } from 'react-native';
import styles from '../../../../../../src/screens/search/home/home.styles';
import Filter from '../../../../../../src/screens/search/home/filter';
import PositionSearch from '../../../../../../src/screens/search/home/portfolio-position-search';
import RecentSearch from '../../../../../../src/screens/search/home/recent-search';
import { createContainer } from '@dbk-legacy/muster/react';
import NoResults from '../../../../../../src/screens/search/home/no-search-results';
import ScrollableLayout from '../../../../../../src/components/common/scrollable-layout';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
const TOP_RECENT_SEARCH = 0;
const PORTFOLIO_POSITION_RECENT_SEARCH = 1;

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      viewNumber: TOP_RECENT_SEARCH,
      searchText: '',
    }
    this.props.search.onRecentSearch(10);
    this.props.search.setHidePositionList(true);
  }

  updateSearchText = (text) => {
    let number = this.state.viewNumber;
    let searchTXT = text.trim();
    if (number == TOP_RECENT_SEARCH && searchTXT != '') {
      this.setState({ viewNumber: PORTFOLIO_POSITION_RECENT_SEARCH });
    }
    if (text.length <= 2) {
      this.props.search.callClearFliter();
    } else {
      this.props.search.callClearFliter();
      this.props.search.setLazyLodingCount(0);
      this.setState({ searchText: searchTXT });
      this.props.search.setHidePositionList(true);
      this.setState({ loadingFlag: true });
      setTimeout(() => {
        this.props.search.onPortfolioOrPositionSearch(text).then((success) => {
          this.setState({ loadingFlag: false });
        });
      }, 10);
    }
  }

  selectedRow = (obj) => {
    let pfPosId = obj.pfPosId;
    let shortAssetName = obj.assetShortDesc;
    let pfId = obj.pfId;
    if (pfPosId == null || pfPosId == '' || pfPosId.length == 0) {
      this.navigateToSelectedPortfolio(pfId);
    } else {
      this.checkAndChangeSelectedPortfolio(pfId);
      this.props.search.onSaveOrUpdateSearchText(obj);
      this.navigateToSelectedAsset(shortAssetName, pfPosId);
    }
  }

  selectedPositionRow = (obj) => {
    let pfPosId = obj.psPosId;
    let shortAssetName = obj.assetShortDesc;
    let pfId = obj.pfId;
    if (pfPosId == null || pfPosId == '' || pfPosId.length == 0) {
      this.navigateToSelectedPortfolio(pfId);
    } else {
      this.checkAndChangeSelectedPortfolio(pfId);
      this.props.search.onSaveOrUpdateSearchText(obj);
      this.navigateToSelectedAsset(shortAssetName, pfPosId);
    }
  }

  checkAndChangeSelectedPortfolio(pfId) {
    let portfolioString = pfId;
    let portfolio = portfolioString.replace('.', '-');
    this.props.search.setFilterPortfolioId(portfolio);
    this.props.app.user.setSelectedPortfolioId(portfolio);
    this.props.clearData();
    const portfolios = this.props.search.portfolioIds;
    if (portfolios != undefined && portfolios.length > 0) {
      for (let value of portfolios) {
        if (value.id === portfolio) {
          this.props.app.user.setSelectedPortfolioData(value);
          this.props.auth.setPaymentAvailable(value.isPaymentAvailable);
          break;
        }
      }
    }
  }

  navigateToSelectedPortfolio(pfId) {
    this.checkAndChangeSelectedPortfolio(pfId);
    this.props.changePage('/portfolios', true);
  }

  navigateToSelectedAsset(shortAssetName, pfPosId) {

    this.props.search.setFilterPositionId(pfPosId);
    this.props.portfolio.setAssetClassName(shortAssetName);
    this.props.changePage({ pathname: '/portfolios/genericAssets' });

  }

  componentWillReceiveProps(nextProps) {
    this.props.search.searchData = nextProps.search.searchData;
  }

  render() {
    let searchData = [];
    searchData = this.props.search.searchData === undefined ? [] : this.props.search.searchData;
    let { searchText, loadingFlag } = this.state;
    let view = null;
    let number = this.state.viewNumber;
    let dataLength = searchData.length;

    if (number == TOP_RECENT_SEARCH) {
      if (dataLength < 1) {
        setTimeout(() => { view = <NoResults data={searchData} />; }
          , 500);
      } else {
        if (dataLength > 0 && searchData[0].statusCode === '401')
          view = <NoResults data={searchData} />;
        else
          view = <RecentSearch data={searchData} selectedRow={this.selectedRow} />;
      }
    }
    if (number == PORTFOLIO_POSITION_RECENT_SEARCH) {
      if ((dataLength == 0) || (dataLength >= 1 && searchData[0].statusCode === '401')) {
        view = <View><NoResults data={searchData} /></View>;
      } else if ((dataLength >= 1 && searchData[0].statusCode === '401') || dataLength == 0) {
        view = <View style={styles.container}><NoResults data={searchData} /></View>;
      } else if (dataLength >= 1 && (searchData[0].statusCode != '401' || searchData[0].statusCode == undefined)) {
        view = <View style={styles.container}><PositionSearch data={searchData} selectedRow={this.selectedPositionRow} /></View>;
      } else if (dataLength >= 1 && (searchData[0].statusCode == undefined || searchData[0].statusCode != '401')) {
        view = <View style={styles.container}><PositionSearch data={searchData} selectedRow={this.selectedPositionRow} /></View>;
      }
    }

    return (
      <ScrollableLayout
        testID="Profile-view"
        body={
          <div>
            <Filter updateSearchText={this.updateSearchText} />
            {loadingFlag && <View style={styles.loading}><LoadingCircle></LoadingCircle></View>}
            {!loadingFlag && view}
          </div>
        }
      />
    );
  }
}

Home.propTypes = {
  searchData: PropTypes.string,
};

export default createContainer({
  $renderLoading: () => <LoadingCircle />,
  $queries: {
    changePage: { $call: 'ui.history.push' },
    clearData: { $call: 'portfolio.clearData' },
    search: {
      onRecentSearch: { $call: 'getRecentSearchData' },
      onPortfolioOrPositionSearch: { $call: 'getPortfolioOrPositionData' },
      searchData: true,
      portfolioIds: true,
      lazyLoadingCount: true,
      setFilterPositionId: { $set: 'filter.positionId' },
      setFilterPortfolioId: { $set: 'filter.portfolioId' },
      onSaveOrUpdateSearchText: { $call: 'onSaveOrUpdateSearchText' },
      setSelectedAssetClass: { $set: 'selectedAssetClass' },
      setHidePositionList: {
        $set: 'hidePositionList',
      },
      setLazyLodingCount: {
        $set: 'lazyLoadingCount',
      },
      hidePositionList: true,
      busy: true,
      callClearFliter: {
        $call: 'clearSearchData',
      },
    },
    auth: {
      setPaymentAvailable: { $set: 'isPaymentCheck' },
    },
    portfolio: {
      setAssetClassName: { $set: 'assetClassName' },
    },
    app: {
      user: {
        selectedPortfolioId: true,
        setSelectedPortfolioId: {
          $set: 'selectedPortfolioId',
        },
        setSelectedPortfolioData: {
          $set: 'selectedPortfolioData',
        },
      },
      global: {
        deviceInfo: {
          isTablet: true,
        }
      }
    },
  },
})(Home);
